module.exports = __webpack_public_path__ + "img/pause.c8d53c82.svg";